// xlsx-js-style: fork drop-in của SheetJS (cùng API XLSX.utils) nhưng hỗ trợ
// ghi style ô (font/màu/border). Bản "xlsx" gốc bỏ style khi ghi file.
import * as XLSX from "xlsx-js-style";
import moment from "moment-timezone";
import toast from "react-hot-toast";
import { delay } from "./utils";
const TIMEZONE = "Asia/Ho_Chi_Minh";

export const roundNumber = (value, decimals = 4) => {
  if (typeof value === "number" && !Number.isInteger(value)) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
  }
  return value;
};

export const roundNumber0 = (value, decimals = 0) => {
  if (typeof value === "number" && !Number.isInteger(value)) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
  }
  return value;
};

function decimalToTime(decimal) {
  const totalHours = decimal * 24;

  const hours = Math.floor(totalHours);
  const minutes = Math.floor((totalHours - hours) * 60);
  const seconds = Math.floor(((totalHours - hours) * 60 - minutes) * 60);

  const formattedHours = String(hours).padStart(2, "0");

  return `${formattedHours}:${String(minutes).padStart(2, "0")}:${String(
    seconds,
  ).padStart(2, "0")}`;
}

function decimalToDate(decimal) {
  const baseDate = new Date(1900, 0, 1);
  const date = new Date(baseDate.getTime() + decimal * 24 * 60 * 60 * 1000);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

function getDecimalToDate(decimal) {
  const baseDate = new Date(1900, 0, 0);
  const date = new Date(
    baseDate.getTime() + decimal * 24 * 60 * 60 * 1000 - 6 * 3000 * 1000,
  );

  return date;
}

function toNumber(value) {
  if (!value) return null; // Nếu giá trị rỗng, trả về null

  const cleanedValue = value.toString().trim().replace(",", ""); // Chuyển dấu , → .
  const numberValue = Number(cleanedValue);

  return isNaN(numberValue) ? null : numberValue; // Nếu NaN, trả về null
}

const parseDate = (value) => {
  if (typeof value === "string" && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
    const [day, month, year] = value.split("/");
    return `${year}-${month}-${day}`;
  }

  if (typeof value === "number") {
    // const baseDate = new Date(1900, 0, 1);
    const baseDate = moment.tz("1900-01-01", TIMEZONE);
    let offset = value;

    if (value > 59) {
      offset -= 1;
    }

    const date = new Date(baseDate.valueOf() + offset * 24 * 60 * 60 * 1000);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  return value;
};

function excelDateToJSDate(serial) {
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  return new Date(excelEpoch.getTime() + serial * 24 * 60 * 60 * 1000);
}

const normalizeDateWithMoment = (value) => {
  if (value === null || value === undefined) return value;

  // Nếu là Excel serial number
  if (typeof value === "number") {
    return excelDateToJSDate(value).toISOString().replace("Z", "+00:00");
  }

  const s = String(value).trim();
  if (!s) return "";

  const m = moment(
    s,
    ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601],
    true,
  );

  if (!m.isValid()) return value;

  return m.format("YYYY-MM-DD");
};

export const importFile = (
  event,
  columnMappingReverse,
  typeValue,
  callback,
  raw = true,
) => {
  const file = event.target.files[0];
  const reader = new FileReader();

  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    // Lấy sheet đầu tiên của file
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Chuyển đổi sheet thành JSON
    const sheetToJsonOption = {};
    if (!raw) {
      sheetToJsonOption.raw = false;
    }
    const jsonData = XLSX.utils.sheet_to_json(worksheet, sheetToJsonOption);

    // Ánh xạ ngược từ tiếng Việt về tên cột gốc
    const mappedData = jsonData.map((item, index) => {
      const mappedItem = {};
      for (let key in item) {
        let keyValue = key;
        if (index === 0) {
          key = key?.trim() || key;
        } else {
          key = key?.trim() || key;
        }

        let originalKey = columnMappingReverse[key] || key;

        let value = item[keyValue];
        // Flag: các trường tỷ lệ/% cần giữ nguyên độ chính xác cao, không làm tròn 4 số
        let isRateField = false;
        if (value === "#ERROR!") {
          value = "";
        }

        if (
          originalKey === "name" ||
          originalKey === "projectCode" ||
          originalKey === "customerCode" ||
          originalKey === "apartmentCode" ||
          originalKey === "identificationNumber" ||
          originalKey === "businessTaxCode" ||
          originalKey === "fullName" ||
          originalKey === "employeeCode" ||
          originalKey === "employeeName" ||
          originalKey === "deviceCode" ||
          originalKey === "monthYear" ||
          // Ghi chú đợt thanh toán PDV (import)
          originalKey === "paymentNote"
        ) {
          value = value?.toString();
        }

        if (
          originalKey === "code" ||
          originalKey === "email" ||
          originalKey === "phone" ||
          // Mã căn / mã nhân viên: bỏ mọi dấu cách/xuống dòng để tránh lệch khi
          // so khớp code (vd " 2001" -> "2001"), gây "không tìm thấy" khi import/xoá.
          originalKey === "codeApartment" ||
          originalKey === "codeSale"
        ) {
          value = value
            ?.toString()
            .replace(/\s+|\n+/g, "")
            .trim();
        }

        // giới tính
        if (originalKey === "gender") {
          const genderMap = {
            NAM: 0,
            NỮ: 1,
            KHÁC: 2,
          };

          value = genderMap[value?.toString().toUpperCase()] ?? value;
        }

        // ngày
        const dateFields = [
          "dateOfBirth",
          "guaranteeDate",
          "depositDate",
          "dateOfIdentification",
          "startTime",
          "endTime",
          "dateTime",
          "transactionDate",
          "matchingDate",
          "bookingTime",
          "disbursementDate",
        ];

        // if (dateFields.includes(originalKey) && typeof value === "number") {
        //   value = excelDateToJSDate(value).toISOString().replace("Z", "+00:00");
        // }

        if (dateFields.includes(originalKey)) {
          value = normalizeDateWithMoment(value);
        }

        if (originalKey === "checkinTime" && typeof value === "number") {
          value = decimalToTime(value);
        }

        if (originalKey === "builtUpArea" && typeof value !== "number") {
          value = toNumber(value);
        }

        if (originalKey === "grossFloorArea" && typeof value !== "number") {
          value = toNumber(value);
        }

        if (originalKey === "areaOfWater" && typeof value !== "number") {
          value = toNumber(value);
        }

        if (originalKey === "length" && typeof value !== "number") {
          value = toNumber(value);
        }

        if (originalKey === "width" && typeof value !== "number") {
          value = toNumber(value);
        }

        if (originalKey === "bookingTime") {
          value = parseDate(value);
        }

        if (originalKey === "priceTime") {
          value = parseDate(value);
        }

        if (originalKey === "codeApartment") {
          value = value?.toString();
        }

        // trang thái hoạt động
        if (originalKey === "status") {
          if (
            value === "Đang làm việc" ||
            value === "Đang hoạt động" ||
            value === "Hoạt động"
          ) {
            value = 0;
          } else {
            value = 1;
          }
        }

        if (originalKey === "branchName") {
          if (value === "Cốm Vòng") {
            value = "Hội sở Hà Nội";
          }
        }

        if (originalKey === "department") {
          if (value === "Khối kinh doanh") {
            value = 1;
          } else if (value === "Khối hỗ trợ kinh doanh") {
            value = 0;
          } else if (value === "Khối giám đốc") {
            value = 2;
          }
        }

        if (
          originalKey === "price" ||
          originalKey === "priceForCustomers" ||
          originalKey === "estimatedServiceFeePrice" ||
          originalKey === "priceForCommission" ||
          originalKey === "totalValue" ||
          originalKey === "kRate" ||
          // import phí dịch vụ
          originalKey === "hotBonusPercent" ||
          originalKey === "priceCVKDEliteSale1" ||
          originalKey === "priceCVKDSale1" ||
          originalKey === "priceGDK" ||
          originalKey === "priceGDKCL" ||
          originalKey === "priceGDKDH" ||
          originalKey === "priceGDKDT" ||
          originalKey === "priceGDV" ||
          originalKey === "priceGDVCL" ||
          originalKey === "priceGDVDH" ||
          originalKey === "priceGDVDT" ||
          originalKey === "pricePdv" ||
          originalKey === "priceTGD" ||
          originalKey === "priceTNMSHSale1" ||
          originalKey === "priceTNSale1" ||
          originalKey === "priceTransaction" ||
          originalKey === "pricetotalRoseSalePdv" ||
          originalKey === "totalStandardWorking" ||
          originalKey === "kRate" ||
          originalKey === "length" ||
          originalKey === "ncttGDKCL" ||
          originalKey === "ncttGDKDH" ||
          originalKey === "ncttGDKDT" ||
          originalKey === "ncttGDVCL" ||
          originalKey === "ncttGDVDH" ||
          originalKey === "ncttGDVDT" ||
          originalKey === "ncttSale1" ||
          originalKey === "pointGDKCL" ||
          originalKey === "pointGDKDH" ||
          originalKey === "pointGDKDT" ||
          originalKey === "pointGDVCL" ||
          originalKey === "pointGDVDH" ||
          originalKey === "pointGDVDT" ||
          originalKey === "pointGTDL" ||
          originalKey === "pointSale1" ||
          originalKey === "price" ||
          originalKey === "totalRoseSale" ||
          originalKey === "totalStandardWorking" ||
          originalKey === "totalTNSale" ||
          originalKey === "totalValue" ||
          originalKey === "priceTNSale2" ||
          originalKey === "priceTNMSHSale2" ||
          originalKey === "priceCVKDEliteSale2" ||
          originalKey === "priceCVKDSale2" ||
          originalKey === "bonusSale1" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceSale1" ||
          originalKey === "bonusSale2" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceSale2" ||
          originalKey === "bonusGDKDH" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDKDH" ||
          originalKey === "bonusGDKDT" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDKDT" ||
          originalKey === "bonusGDKCL" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDKCL" ||
          originalKey === "bonusGDVDH" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDVDH" ||
          originalKey === "bonusGDVDT" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDVDT" ||
          originalKey === "bonusGĐVCL" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGDVCL" ||
          originalKey === "bonusGTĐL" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceGTDL" ||
          originalKey === "bonusTGĐ" ||
          originalKey === "accountingFromPreviousPeriodOrAdvanceTGD" ||
          originalKey === "ncttTGD" ||
          originalKey === "rateCVKD" ||
          originalKey === "rate" ||
          originalKey === "rateCVKDElite" ||
          originalKey === "rateGDK" ||
          originalKey === "rateGDKCL" ||
          originalKey === "rateGDKDH" ||
          originalKey === "rateGDKDT" ||
          originalKey === "rateGDV" ||
          originalKey === "rateGDVCL" ||
          originalKey === "rateGDVDH" ||
          originalKey === "rateGDVDT" ||
          originalKey === "rateGTDL" ||
          originalKey === "rateSale1" ||
          originalKey === "rateTGD" ||
          originalKey === "rateTN" ||
          originalKey === "rateTNMSH" ||
          originalKey === "rateTransaction" ||
          originalKey === "rateSale2" ||
          originalKey === "ttda" ||
          originalKey === "priceSale" ||
          // Import thanh toán PDV — cột Thưởng nóng
          originalKey === "hotBonus" ||
          originalKey === "transactionRate" ||
          originalKey === "amountHeld" ||
          originalKey === "amountPaid" ||
          // Import thanh toán CCMG — 2 cột chỉ lưu trữ (Số trước thuế, Thuế)
          originalKey === "amountBeforeTax" ||
          originalKey === "taxAmount" ||
          // Thuế TNCN nhập tay trong file tính phí dịch vụ
          originalKey === "personalIncomeTaxSale1" ||
          originalKey === "personalIncomeTaxSale2" ||
          originalKey === "personalIncomeTaxGDKDH" ||
          originalKey === "personalIncomeTaxGDKDT" ||
          originalKey === "personalIncomeTaxGDKCL" ||
          originalKey === "personalIncomeTaxGDVDH" ||
          originalKey === "personalIncomeTaxGDVDT" ||
          originalKey === "personalIncomeTaxGDVCL" ||
          originalKey === "personalIncomeTaxGTDL" ||
          originalKey === "personalIncomeTaxTGD"
        ) {
          // Đánh dấu là trường tỷ lệ → giữ nguyên độ chính xác, không làm tròn 4 số thập phân
          isRateField = true;
          // Chỉ áp dụng parse string khi value THỰC SỰ là chuỗi từ file (CSV hoặc ô text trong Excel).
          if (typeof value === "number") {
            // Giá trị đã là số hợp lệ từ XLSX – giữ nguyên, không parse lại
            value = value;
          } else if (typeValue === 1) {
            // VN/EU: "100.000.000,1" -> 100000000.1
            value = Number(
              value
                ?.toString()
                .replace(/\./g, "") // Xóa tất cả dấu chấm (ngăn cách nghìn)
                .replace(/,/g, "."), // Đổi dấu phẩy thành dấu chấm (thập phân)
            );
          } else if (typeValue === 2) {
            // US: "100,000,000.1" -> 100000000.1
            value = Number(
              value?.toString()?.replace(/,/g, ""), // Xóa tất cả dấu phẩy (ngăn cách nghìn)
            );
          } else {
            // Trường hợp khác: bỏ hết chấm, phẩy
            value = Number(
              value?.toString()?.replace(/[.,]/g, ""), // Xóa tất cả dấu chấm và phẩy
            );
          }
        }

        // mappedItem[originalKey] = value;
        // Trường tỷ lệ/% (transactionRate, rateGDK, ...): giữ nguyên độ chính xác đầy đủ từ Excel
        // Các trường còn lại: làm tròn 4 số thập phân như bình thường
        mappedItem[originalKey] = isRateField ? value : roundNumber(value);
      }
      return mappedItem;
    });

    callback(mappedData); // Trả về dữ liệu JSON đã được ánh xạ thông qua callback
  };

  reader.readAsArrayBuffer(file);
};

/**
 * Wrap importFile (parse excel/csv) + toast loader + callback xử lý data
 *
 * @param {Object} options
 * @param {FileList} options.files - inputFileRef.current.files
 * @param {Object} options.mapping - mapping header -> field
 * @param {number} options.typeValue - dấu phân cách (1/2...)
 * @param {(importedData:any[])=>Promise<any>} options.onData - callback nhận importedData
 * @param {Object} options.toastMessages - custom message
 * @param {boolean} options.autoDismiss - tự dismiss (khi không dùng toast.promise)
 */
export const importWithToast = async ({
  files,
  mapping,
  typeValue = 1,
  onData,
  toastMessages,
  minLoadingMs = 350,
  raw = true,
}) => {
  const msgs = {
    loading: "Đang xử lý file...",
    success: "Thành công",
    error: "Thất bại, vui lòng kiểm tra lại file.",
    ...(toastMessages || {}),
  };

  if (!files || !files[0]) {
    toast.error("Vui lòng chọn file để import.");
    return { ok: false, error: new Error("NO_FILE") };
  }

  const fileEvent = { target: { files } };

  const run = async () => {
    if (typeof onData !== "function") throw new Error("INVALID_HANDLER");

    const job = new Promise((resolve, reject) => {
      importFile(
        fileEvent,
        mapping,
        typeValue,
        async (importedData) => {
          try {
            const result = await onData(importedData);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        },
        raw,
      );
    });

    const [result] = await Promise.all([job, delay(minLoadingMs)]);
    return result;
  };

  try {
    const result = await toast.promise(run(), {
      loading: msgs.loading,
      success: msgs.success,
      error: msgs.error,
    });

    return { ok: true, result };
  } catch (err) {
    console.error(err);
    return { ok: false, error: err };
  }
};

export const exportFile = (
  data,
  columnMapping,
  fileName = "output.xlsx",
  fileSheet1 = "Sheet1",
  data2 = null,
  columnMapping2 = null,
  fileSheet2 = "Sheet2",
  data3,
  columnMapping3 = null,
  fileSheet3 = "Tổng PDV",
  // options.highlightHeaders: mảng tên cột (tiêu đề) cần tô nền VÀNG thay vì xanh.
  // options.autoFilter: true → bật bộ lọc (nút ▼) ở dòng tiêu đề của mỗi sheet.
  options = {},
) => {
  // Set tên tiêu đề cần tô vàng (so khớp không phân biệt hoa/thường, đã trim).
  const highlightHeaderSet = new Set(
    (options.highlightHeaders || []).map((h) => String(h).trim().toLowerCase()),
  );
  // Tên cột cần ép định dạng tiền dù KHÔNG khớp regex tên cột — dùng cho các cột
  // động (vd cột theo đợt mở bán ở tab "Tổng PDV" có tiêu đề là tên dự án nên
  // regex không nhận ra là cột tiền -> số bị "sót" định dạng phân tách nghìn).
  const moneyHeaderSet = new Set(
    (options.moneyHeaders || []).map((h) => String(h).trim().toLowerCase()),
  );
  const dateFields = [
    "dateOfBirth",
    "guaranteeDate",
    "depositDate",
    "dateOfIdentification",
    "startTime",
    "endTime",
  ];

  const formatData = (data, columnMapping) => {
    return data.map((item) => {
      const formattedItem = {};
      for (const key in item) {
        const newKey = columnMapping[key] || key;
        let value = item[key];

        // Nếu là chuỗi dạng dd/MM/yyyy
        if (
          dateFields.includes(key) &&
          typeof value === "string" &&
          value.includes("/")
        ) {
          const [day, month, year] = value.split("/");
          value = new Date(`${year}-${month}-${day}`);
        }

        // Nếu là Date hợp lệ
        if (value instanceof Date && !isNaN(value)) {
          formattedItem[newKey] = value;
        } else {
          formattedItem[newKey] = value;
        }
      }
      return formattedItem;
    });
  };

  const createSheet = (formattedData) => {
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Định dạng tiền tệ: GIỮ Ô LÀ SỐ THẬT + gắn định dạng "#,##0" để còn
    // SUM/sort được. Dấu phân tách hiển thị theo cài đặt Excel của máy mở
    // file (máy để dấu chấm -> "36.689.822", máy để dấu phẩy -> "36,689,822").
    // (Không thể vừa ép cứng dấu chấm trong file vừa giữ là số -> ưu tiên SUM.)
    //
    // QUAN TRỌNG: chỉ format cột tiền dựa theo TÊN CỘT (không theo độ lớn),
    // để không nhầm với ngày/giờ (vd "TG bắt đầu" là số serial ~46000),
    // số lượng, tỷ lệ... Nhận diện cột tiền + loại trừ cột tỷ lệ.
    const moneyHeaderRe =
      /(số tiền|thành tiền|tổng tiền|tổng số tiền|giá tính|giá niêm|giá trị|thưởng nóng|thuế|chứng chỉ|ký quỹ|kt do|tạm ứng|pdv còn lại|pdv chưa thanh toán|pdv sau thuế|tổng cộng|tổng tn|tổng hh|phí dịch vụ|doanh thu)/i;
    const rateHeaderRe = /(tỷ lệ|tỉ lệ)/i;
    // Cột MÃ dạng chuỗi toàn chữ số (mã số thuế, CCCD): phải giữ nguyên là text.
    // "Mã Số Thuế" khớp "thuế" của moneyHeaderRe nên trước đây bị ép thành số
    // và gắn định dạng "#,##0" (vd 123123 -> 123.123), CCCD thì mất số 0 ở đầu.
    const textHeaderRe = /(mã số thuế|căn cước công dân|số cccd|số cmnd)/i;
    // Loại trừ "Ngày cấp ..." / "Nơi cấp ..." vì đó là cột ngày và địa danh.
    const textExcludeRe = /(ngày|nơi)/i;

    const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1");
    const moneyCols = [];
    const textCols = [];
    for (let C = range.s.c; C <= range.e.c; C++) {
      const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
      const label = header && header.v != null ? String(header.v) : "";
      if (textHeaderRe.test(label) && !textExcludeRe.test(label)) {
        textCols.push(C);
        continue;
      }
      const isMoneyByName =
        moneyHeaderRe.test(label) && !rateHeaderRe.test(label);
      const isMoneyExplicit = moneyHeaderSet.has(label.trim().toLowerCase());
      if (isMoneyByName || isMoneyExplicit) {
        moneyCols.push(C);
      }
    }

    // Ép các cột mã về text (t:"s" + định dạng "@") để Excel không tự đổi sang số.
    for (let R = range.s.r + 1; R <= range.e.r; R++) {
      for (const C of textCols) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (!cell || cell.v === null || cell.v === undefined || cell.v === "")
          continue;

        cell.v = String(cell.v);
        cell.t = "s";
        cell.z = "@";
      }
    }

    for (let R = range.s.r + 1; R <= range.e.r; R++) {
      for (const C of moneyCols) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (!cell || cell.v === null || cell.v === undefined || cell.v === "")
          continue;

        // Lấy giá trị số dù ô là số (t:"n") hay chuỗi số (t:"s", vd "35677024923"
        // hoặc "10665897943.617022"). Bỏ ký tự không phải số trước khi parse.
        let num;
        if (cell.t === "n") {
          num = cell.v;
        } else if (cell.t === "s") {
          const raw = String(cell.v).replace(/[^\d.-]/g, "");
          if (raw !== "" && !isNaN(Number(raw))) num = Number(raw);
        }
        if (num === undefined || isNaN(num)) continue;

        // Giữ là số + định dạng phân tách nghìn (separator theo locale của máy).
        cell.v = num;
        cell.t = "n";
        cell.z = "#,##0";
      }
    }

    const columnWidths = Object.keys(formattedData[0] || {}).map((key) => {
      const maxColumnWidth = Math.max(
        key.length,
        ...formattedData.map((row) =>
          row[key] ? row[key].toString().length : 10,
        ),
      );
      return { wch: maxColumnWidth + 2 };
    });
    worksheet["!cols"] = columnWidths;

    // ==== STYLE ====
    // Yêu cầu: font Times New Roman, cỡ 10; dòng tiêu đề (header) màu xanh nhạt,
    // in đậm, cỡ 12; border mỏng cho tất cả các dòng/cột.
    const borderThin = {
      top: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    for (let R = range.s.r; R <= range.e.r; R++) {
      const isHeader = R === range.s.r;
      for (let C = range.s.c; C <= range.e.c; C++) {
        const ref = XLSX.utils.encode_cell({ r: R, c: C });
        // Tạo ô rỗng để border phủ kín mọi ô trong vùng dữ liệu.
        if (!worksheet[ref]) worksheet[ref] = { t: "s", v: "" };
        const cell = worksheet[ref];
        // Tiêu đề nằm trong danh sách highlight → nền vàng; còn lại nền xanh nhạt.
        const isHighlightHeader =
          isHeader &&
          highlightHeaderSet.has(String(cell.v || "").trim().toLowerCase());
        cell.s = {
          font: {
            name: "Times New Roman",
            sz: isHeader ? 12 : 10,
            bold: isHeader,
          },
          alignment: isHeader
            ? { vertical: "center", horizontal: "center", wrapText: true }
            : { vertical: "top", wrapText: true },
          border: borderThin,
          ...(isHeader && {
            fill: {
              patternType: "solid",
              fgColor: { rgb: isHighlightHeader ? "FFFF00" : "A2D8FA" },
            },
          }),
        };
      }
    }

    // Tăng chiều cao dòng tiêu đề cho thoáng (giả lập padding trên/dưới).
    // Header canh giữa theo chiều dọc nên chữ nằm giữa -> nhìn như có padding.
    worksheet["!rows"] = worksheet["!rows"] || [];
    worksheet["!rows"][range.s.r] = { hpt: 26 };

    // Bộ lọc ở dòng tiêu đề (chỉ khi được yêu cầu, các file xuất khác giữ nguyên).
    if (options.autoFilter) {
      worksheet["!autofilter"] = { ref: XLSX.utils.encode_range(range) };
    }

    return worksheet;
  };

  const workbook = XLSX.utils.book_new();

  // Sheet 1
  if (data && data.length > 0) {
    const formattedData = formatData(data, columnMapping);
    const worksheet1 = createSheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet1, fileSheet1);
  }

  // Sheet 2 (nếu có)
  if (data2 && data2.length > 0) {
    const formattedData2 = formatData(data2, columnMapping2);
    const worksheet2 = createSheet(formattedData2);
    XLSX.utils.book_append_sheet(workbook, worksheet2, fileSheet2);
  }

  // Sheet 3 (nếu có)
  if (data3 && data3.length > 0) {
    const formattedData3 = formatData(data3, columnMapping3);
    const worksheet3 = createSheet(formattedData3);
    XLSX.utils.book_append_sheet(workbook, worksheet3, fileSheet3);
  }

  XLSX.writeFile(workbook, fileName);
};

const isEmptyData = (data) => {
  if (!data) return true;
  if (Array.isArray(data)) return data.length === 0;
  return false;
};

/**
 * Export excel khi data đã có sẵn (export mẫu)
 */
export const exportExcelLocal = async ({
  data,
  mapping,
  filename = "export.xlsx",
  toastMessages,
  minLoadingMs = 350,
  // Mảng tên tiêu đề cần tô nền vàng trong file (tuỳ chọn).
  highlightHeaders,
}) => {
  const msgs = {
    loading: "Đang xuất file...",
    success: "Download file thành công",
    noData: "Không có dữ liệu",
    error: "Export lỗi",
    ...(toastMessages || {}),
  };

  const run = async () => {
    if (!mapping || typeof mapping !== "object")
      throw new Error("INVALID_MAPPING");
    if (isEmptyData(data)) throw new Error("NO_DATA");

    if (minLoadingMs > 0) await new Promise((r) => setTimeout(r, minLoadingMs));

    // Truyền undefined cho các tham số giữa để dùng default; chỉ set options cuối.
    exportFile(
      data,
      mapping,
      filename,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      { highlightHeaders },
    );
    return true;
  };

  try {
    await toast.promise(run(), {
      loading: msgs.loading,
      success: msgs.success,
      error: (err) => (err?.message === "NO_DATA" ? msgs.noData : msgs.error),
    });
    return { ok: true };
  } catch (err) {
    console.error(err);
    return { ok: false, error: err };
  }
};

/**
 * Export excel từ API (loader bọc cả call api + export)
 * fetcher: async () => data
 */
export const exportExcelFromApi = async ({
  fetcher,
  mapping,
  filename = "export.xlsx",
  toastMessages,
  minLoadingMs = 150,
  // true → file có bộ lọc ở dòng tiêu đề
  autoFilter = false,
}) => {
  const msgs = {
    loading: "Đang xuất file...",
    success: "Xuất file thành công",
    noData: "Không có dữ liệu",
    error: "Xuất file thất bại",
    ...(toastMessages || {}),
  };

  const run = async () => {
    if (typeof fetcher !== "function") throw new Error("INVALID_FETCHER");
    if (!mapping || typeof mapping !== "object")
      throw new Error("INVALID_MAPPING");

    const data = await fetcher();

    if (isEmptyData(data)) throw new Error("NO_DATA");

    if (minLoadingMs > 0) await new Promise((r) => setTimeout(r, minLoadingMs));

    if (autoFilter) {
      exportFile(
        data,
        mapping,
        filename,
        "Sheet1",
        null,
        null,
        "Sheet2",
        undefined,
        null,
        "Tổng PDV",
        { autoFilter: true },
      );
    } else {
      exportFile(data, mapping, filename);
    }
    return data;
  };

  try {
    const data = await toast.promise(run(), {
      loading: msgs.loading,
      success: msgs.success,
      error: (err) => (err?.message === "NO_DATA" ? msgs.noData : msgs.error),
    });
    return { ok: true, data };
  } catch (err) {
    console.error(err);
    return { ok: false, error: err };
  }
};

export const formatDateDb = (value, type = 0) => {
  const dateTime = new Date(value);
  if (type) {
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
  return formattedDate;
};

export const formatMonthDb = (value, type = 0) => {
  const dateTime = new Date(value);
  if (type) {
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    month: "numeric",
    year: "numeric",
  });
  return formattedDate;
};

export const currentformatDateDb = (type = 0) => {
  const dateTime = new Date();
  if (type) {
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
  return formattedDate;
};

export const formatDateHourDb = (value, type = 0) => {
  const dateTime = new Date(value);

  if (type) {
    // Trả về định dạng yyyy-mm-dd HH:MM:ss
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const hours = String(dateTime.getHours()).padStart(2, "0");
    const minutes = String(dateTime.getMinutes()).padStart(2, "0");
    const seconds = String(dateTime.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // Trả về định dạng dd/mm/yyyy HH:MM:ss (theo en-GB)
  const date = dateTime.toLocaleDateString("en-GB");
  const time = dateTime.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return `${time} ${date}`;
};

export const currentDateHourDb = (type = 0) => {
  const dateTime = new Date();

  if (type) {
    // Trả về định dạng yyyy-mm-dd HH:MM:ss
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const hours = String(dateTime.getHours()).padStart(2, "0");
    const minutes = String(dateTime.getMinutes()).padStart(2, "0");
    const seconds = String(dateTime.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // Trả về định dạng dd/mm/yyyy HH:MM:ss (theo en-GB)
  const date = dateTime.toLocaleDateString("en-GB");
  const time = dateTime.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return `${time} ${date}`;
};

export const formatTimeDb = (value, type = 0) => {
  const checkinTime = new Date(value);
  if (type) {
    const formattedTime = checkinTime.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return formattedTime;
  }
  const formattedTime = checkinTime.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return formattedTime;
};

export const removeFileExtension = (name) => {
  // Kiểm tra xem tên file có chứa các phần mở rộng như .doc, .pdf không
  const extensions = [".doc", ".pdf", ".xls", ".xlsx", ".ppt", ".txt"]; // Các phần mở rộng cần kiểm tra
  for (const ext of extensions) {
    if (name && name.includes(ext)) {
      return name.replace(ext, ""); // Xóa phần mở rộng
    }
  }
  return name;
};
